var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 20,
    viewBox: "0 0 4 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.6923C1.45 19.6923 0.979222 19.4965 0.587667 19.1047C0.195889 18.7131 0 18.2423 0 17.6923C0 17.1423 0.195889 16.6715 0.587667 16.2797C0.979222 15.8881 1.45 15.6923 2 15.6923C2.55 15.6923 3.02078 15.8881 3.41233 16.2797C3.80411 16.6715 4 17.1423 4 17.6923C4 18.2423 3.80411 18.7131 3.41233 19.1047C3.02078 19.4965 2.55 19.6923 2 19.6923ZM2 12C1.45 12 0.979222 11.8041 0.587667 11.4123C0.195889 11.0208 0 10.55 0 10C0 9.45001 0.195889 8.97923 0.587667 8.58768C0.979222 8.1959 1.45 8.00001 2 8.00001C2.55 8.00001 3.02078 8.1959 3.41233 8.58768C3.80411 8.97923 4 9.45001 4 10C4 10.55 3.80411 11.0208 3.41233 11.4123C3.02078 11.8041 2.55 12 2 12ZM2 4.30768C1.45 4.30768 0.979222 4.1119 0.587667 3.72035C0.195889 3.32857 0 2.85768 0 2.30768C0 1.75768 0.195889 1.2869 0.587667 0.895345C0.979222 0.503567 1.45 0.307678 2 0.307678C2.55 0.307678 3.02078 0.503567 3.41233 0.895345C3.80411 1.2869 4 1.75768 4 2.30768C4 2.85768 3.80411 3.32857 3.41233 3.72035C3.02078 4.1119 2.55 4.30768 2 4.30768Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu_dots.a3cd5a5431715a0f9a77956d864e4e03.svg";
export { ForwardRef as ReactComponent };